import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';

import { trackEvent } from 'dibs-tracking';

import { ContemporaryLandingHeaderModule } from '../ContemporaryLandingHeaderModule/ContemporaryLandingHeaderModule';

import styles from './ContemporaryLandingFurnitureTileModule.scss';

const trackClick = item =>
    trackEvent({
        action: 'featured Promotion #2',
        category: 'contemporary landing page interaction',
        label: `${item.caption} clicked|${item.cta}`,
    });

const ContemporaryLandingFurnitureTileModuleComponent = ({ contemporaryLandingRow }) => {
    const item = get(contemporaryLandingRow, 'items[0]');
    if (!item) {
        return null;
    }

    const { cta, imagePath, link, caption } = item;
    return (
        <div className={styles.wrapper}>
            <ContemporaryLandingHeaderModule
                cta={cta}
                imagePath={imagePath}
                linkPath={link}
                onClick={() => trackClick(item)}
                title={caption}
            />
        </div>
    );
};

export const ContemporaryLandingFurnitureTileModule = createFragmentContainer(
    ContemporaryLandingFurnitureTileModuleComponent,
    {
        contemporaryLandingRow: graphql`
            fragment ContemporaryLandingFurnitureTileModule_contemporaryLandingRow on ContemporaryLandingRow {
                ... on ContemporaryLandingRow {
                    items {
                        ... on ContemporaryLandingFurnitureTileSection {
                            caption
                            cta
                            imagePath
                            link
                        }
                    }
                }
            }
        `,
    }
);

ContemporaryLandingFurnitureTileModule.propTypes = {
    ContemporaryLandingRow: PropTypes.object,
};
